var map = {
	"./bank-transfer.svg": 832,
	"./betnearn-ico.svg": 833,
	"./birthday-bonus-ico.svg": 834,
	"./birthday.svg": 835,
	"./bonus-code-ico.svg": 836,
	"./bonus-ico.svg": 837,
	"./bonus-received-ico.svg": 838,
	"./bonus.svg": 839,
	"./business-account-upgrade-ico.svg": 840,
	"./check-in-daily-ico.svg": 841,
	"./checked.svg": 842,
	"./cloud-pointer.svg": 843,
	"./coin.svg": 844,
	"./crypto.svg": 845,
	"./daily-bonus-ico.svg": 846,
	"./daily-limit.svg": 847,
	"./deposit-delay-bonus-ico.svg": 848,
	"./e-wallet.svg": 849,
	"./earn-x33-coin-ico.svg": 850,
	"./email.svg": 851,
	"./facebook.svg": 852,
	"./feedback.svg": 853,
	"./first-bet-ico.svg": 854,
	"./games-rebate-ico.svg": 855,
	"./info.svg": 856,
	"./instagram.svg": 857,
	"./instant-rebate.svg": 858,
	"./live-casino-rebate-ico.svg": 859,
	"./lucky-spin-ico.svg": 860,
	"./messenger.svg": 861,
	"./mobile-app-deposit-ico.svg": 862,
	"./monthly-cash.svg": 863,
	"./msg-activity.svg": 864,
	"./msg-ann.svg": 865,
	"./msg-notice.svg": 866,
	"./new-icon.svg": 867,
	"./people-ico.svg": 868,
	"./quick-pay.svg": 869,
	"./rescue-bonus-ico.svg": 870,
	"./rescue-lc-ico.svg": 871,
	"./rescue-slots-ico.svg": 872,
	"./return.svg": 873,
	"./sc-bc-active-ico.svg": 874,
	"./sc-bc-ico.svg": 875,
	"./sc-bi-active-ico.svg": 876,
	"./sc-bi-ico.svg": 877,
	"./sc-mail-active-ico.svg": 878,
	"./sc-mail-ico.svg": 879,
	"./sc-mp-active-ico.svg": 880,
	"./sc-mp-ico.svg": 881,
	"./sc-pin-active-ico.svg": 882,
	"./sc-pin-ico.svg": 883,
	"./slots-rebate-ico.svg": 884,
	"./sms.svg": 885,
	"./sports-rebate-ico.svg": 886,
	"./telegram.svg": 887,
	"./twitter.svg": 888,
	"./vip-up-level-ico.svg": 889,
	"./vip-weekly-bonus.svg": 890,
	"./wallet-balance-interest-ico.svg": 891,
	"./wallet-ico.svg": 892,
	"./weekly-tournament-ico.svg": 893,
	"./welcome-bonus-188-ico.svg": 894,
	"./welcome-bonus-ico.svg": 895,
	"./whatsapp-original.svg": 896,
	"./whatsapp.svg": 897,
	"./withdrawal-delay-bonus-ico.svg": 898,
	"./withdrawal.svg": 899,
	"./x33-coin.svg": 900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;